import { defineAsyncComponent as i, ref as f, computed as w, onMounted as A, createBlock as v, openBlock as b, withCtx as C, resolveDynamicComponent as O } from "vue";
import { themeProp as g } from "../../composables/useTheme.js";
import j from "./select-box-container/select-box-container.vue.js";
const F = /* @__PURE__ */ Object.assign({
  name: "DsSelectBox"
}, {
  __name: "select-box",
  props: {
    ...g,
    /**
     * Select box labels
     * {
          label: '',
          ariaLabelHint: '',
          clearValueButton: '',
          submitValueButton: '',
          results: ''
        }
     */
    labels: {
      type: Object,
      required: !0
    },
    /**
     * Select box options list
     * Should be an array of objects. Each object need to have mandatory "value", "id", "text" property:
     * [{ id: 'uid', text: 'display text', value: 'value to emit', additionalText: 'more info' }]
     * AdditionalText is optional
     */
    options: {
      type: Array,
      required: !0,
      validator: (e) => e === null || e.every((a) => a && a.id !== void 0 && a.value !== void 0 && a.text !== void 0)
    },
    /**
     * Select box placeholder, to be displayed when there is no selected option
     */
    placeholder: {
      type: String,
      required: !0
    },
    /**
     * Select box value
     */
    value: {
      type: [String, Array],
      default: null
    },
    /**
     * Select box flag, to load the search autocomplete component
     */
    autocomplete: {
      type: Boolean,
      default: !1
    },
    /**
     * Select box flag, to indicate that you can search
     */
    search: {
      type: Boolean,
      default: !1
    },
    /**
     * Select box flag, to indicate that multiple options can be selected
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Select box icon, displayed next to the button text
     */
    icon: {
      type: Object,
      default: null
    },
    /**
     * Select box max length, for search term
     */
    maxLength: {
      type: Number,
      default: 35
    },
    /**
     * Select box default option, first option
     */
    withDefaultOption: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["value"],
  setup(e, { emit: a }) {
    const x = i(
      () => import("./select-box-default.vue.js")
    ), S = i(
      () => import("./select-box-search.vue.js")
    ), B = i(
      () => import("./select-box-search-autocomplete.vue.js")
    ), s = /* @__PURE__ */ new Map([
      ["DsSelectBoxSearch", S],
      ["DsSelectBoxDefault", x],
      ["DsSelectBoxSearchAutocomplete", B]
    ]), p = ["label"], d = ["label", "results"], m = ["results", "ariaLabelHint", "clearValueButton"], h = ["results", "ariaLabelHint", "clearValueButton", "submitValueButton"], l = e, y = a, c = f(), n = f(), u = f(!1);
    l.autocomplete ? (n.value = "DsSelectBoxSearchAutocomplete", u.value = !1) : l.search ? (n.value = "DsSelectBoxSearch", u.value = !1) : (n.value = "DsSelectBoxDefault", u.value = !0);
    const D = w(() => s.has(n.value) ? s.get(n.value) : s.get("DsSelectBoxDefault"));
    A(() => {
      var o, r;
      if (((r = (o = import.meta) == null ? void 0 : o.env) == null ? void 0 : r.MODE) !== "production") {
        if (l.autocomplete && !h.every((t) => t in l.labels))
          throw new Error(
            `Provide labels for select box autocomplete: ${h.join(", ")}`
          );
        if (l.search && !m.every((t) => t in l.labels))
          throw new Error(
            `Provide labels for select box with search: ${m.join(", ")}`
          );
        if (l.multiple && !d.every((t) => t in l.labels))
          throw new Error(
            `Provide labels for select box with multiple: ${d.join(", ")}`
          );
        if (!l.autocomplete && !l.search && !l.multiple && !p.every((t) => t in l.labels))
          throw new Error(
            `Provide labels for select box: ${p.join(", ")}`
          );
      }
    });
    function E() {
      var o;
      (o = c.value) != null && o.handleClickOutside && c.value.handleClickOutside();
    }
    return (o, r) => (b(), v(j, {
      "first-letter-search": u.value,
      onClickOutside: E
    }, {
      default: C((t) => [
        (b(), v(O(D.value), {
          ref_key: "innerComponent",
          ref: c,
          theme: o.theme,
          labels: e.labels,
          options: e.options,
          "with-default-option": e.withDefaultOption,
          placeholder: e.placeholder,
          value: e.value,
          icon: e.icon,
          multiple: e.multiple,
          search: e.search,
          "max-length": e.maxLength,
          "focus-index": t.focusIndex,
          opened: t.opened,
          onOpen: t.open,
          onClose: t.close,
          onFocus: t.focus,
          onValue: r[0] || (r[0] = (L) => y("value", L))
        }, null, 40, ["theme", "labels", "options", "with-default-option", "placeholder", "value", "icon", "multiple", "search", "max-length", "focus-index", "opened", "onOpen", "onClose", "onFocus"]))
      ]),
      _: 1
    }, 8, ["first-letter-search"]));
  }
});
export {
  F as default
};
